import baseService from '../shared/baseService';

const journalistCategoryService = () => baseService('journalists-categories');

export default {
    journalistCategoryService,
};